<script setup lang="ts">
import {useCdnUrl} from '@/composables/cdn-url';

const videoUrl = ref();
const logoExpandedState = useState('logo-expanded-state');

onMounted(() => {
  logoExpandedState.value = 'true';
  const {getOrientation} = useUtils();
  if (getOrientation() === 'portrait' && window.innerWidth <= 414) {
    videoUrl.value = `${useCdnUrl()}/assets/home/background-video-phone`;
  } else if (getOrientation() === 'portrait' && window.innerWidth > 414) {
    videoUrl.value = `${useCdnUrl()}/assets/home/background-video-tablet`;
  } else {
    videoUrl.value = `${useCdnUrl()}/assets/home/background-video-landscape`;
  }
});

onBeforeUnmount(() => {
  logoExpandedState.value = 'true';
});
</script>

<template>
  <section class="home-feature">
    <BackgroundVideo v-if="videoUrl" :src-url="videoUrl" />

    <div class="feature-title">
      <h1 v-html="$t('home_hero.title')" />
      <p v-html="$t('home_hero.sub_title')" />
    </div>
  </section>
</template>

<style lang="scss" scoped>
@use '@/assets/scss/queries';
.home-feature {
  margin: auto;
  max-width: 2560px;
  min-height: 100vh;

  position: relative;
  width: 100vw;

  .feature-title {
    bottom: 0;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding: 8.5rem;
    position: absolute;
    z-index: 1;

    @include queries.for-size(tablet-landscape-down) {
      padding: 6.5rem 3rem;
      text-shadow: 0 0 7px #000;
    }

    @include queries.for-size(phone) {
      bottom: 10%;
    }

    h1 {
      color: white;
      font-size: 5.8rem;
      font-weight: 800;
      line-height: 1;
      margin: 0;
      padding: 0;
      text-shadow: 0 4px 15.1px rgba(0, 0, 0, 0.59);

      @include queries.for-size(phone) {
        font-size: 5rem;
      }
      //text-transform: uppercase;
    }

    p {
      color: white;
      font-size: 2.5rem;
      font-weight: 400;
      margin: 0;
      padding: 0;
      text-shadow: 0 4px 15.1px rgba(0, 0, 0, 0.59);
    }
  }
}
</style>
